import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { INewsDetailGetParams } from "../../../Orchestrator/Types/Interface/ICMSNews";

class NewsCardClickAction extends BaseAction<void, INewsDetailGetParams> {
    override async run(): Promise<void> {
        const { slug } = this.params!;
        updateRecoilState("newsDetailResponseAtom", null);
        _eventBus.emit({
            eventName: "ROUTE_CHANGE",
            data: `/news/${slug}`,
        })
    }
}

export const newsCardClickAction = new NewsCardClickAction();
